import React from "react";

const boards = [
  { id: "stake", label: "Stake" },
  { id: "exclusive", label: "Stake", sub: "Exclusive" },
];

const BoardSwitcher = ({ value, onChange }) => {
  const activeIndex = boards.findIndex((b) => b.id === value);

  return (
    <div data-testid="leaderboard-board-switcher" role="tablist" aria-label="Leaderboard" className="switcher-shell relative grid grid-cols-2 items-center gap-1 w-[420px] max-w-full rounded-full border border-emerald-500/20 bg-[#0d0f13]/80 p-1.5 backdrop-blur-xl">
      {/* Sliding indicator */}
      <span
        className="switcher-indicator absolute top-1.5 bottom-1.5 rounded-full bg-gradient-to-b from-emerald-500/90 to-emerald-600/90 transition-all duration-300 ease-out"
        style={{
          width: "calc(50% - 8px)",
          left: activeIndex === 0 ? "6px" : "calc(50% + 2px)",
        }}
      />

      {boards.map((b) => {
        const active = value === b.id;
        return (
          <button
            key={b.id}
            role="tab"
            aria-selected={active}
            data-testid={`leaderboard-board-${b.id}`}
            onClick={() => onChange(b.id)}
            className={`relative z-10 flex min-w-0 items-center justify-center gap-1.5 rounded-full px-3 sm:px-6 py-3 transition-opacity duration-300 ${
              active ? "opacity-100" : "opacity-60 hover:opacity-90"
            }`}
          >
            <img
              src="/stake-logo.png"
              data-testid={`leaderboard-logo-${b.id}`}
              alt={b.sub ? "Stake Exclusive" : "Stake"}
              className="h-5 w-auto"
            />
            {b.sub && (
              <span
                className={`self-end text-[9px] font-semibold uppercase tracking-[0.18em] mb-0.5 ${
                  active ? "text-emerald-950/90" : "text-emerald-300/90"
                }`}
              >
                {b.sub}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default BoardSwitcher;
